import { PureComponent } from "react";
import clsx from "clsx";
import { v4 as uuid } from "uuid";

import type { ReactNode } from "react";

import "./Label.scss";

export interface LabelProps {
  htmlFor?: string;
  className?: string;
  title?: string;
  visibleCondition?: boolean;
  children?: ReactNode;
}

export class Label extends PureComponent<LabelProps> {
  el: HTMLInputElement;

  render() {
    const id = `id-${uuid()}`;
    const shouldHide =
      typeof this.props.visibleCondition === "boolean" && !this.props.visibleCondition;

    return this.props.children ?
        <label
          title={this.props.title}
          htmlFor={this.props.htmlFor}
          id={id}
          className={clsx("control-label", "tc-label", this.props.className)}
          style={{ display: shouldHide ? "none" : "inline-block" }}
        >
          {this.props.children}
        </label>
      : "";
  }
}
